import { useFormik } from 'formik';

import * as yup from 'yup';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';

import { resetPassword } from 'api';
import RouterLink from 'components/RouterLink/RouterLink';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { ToastSeverity, toastStateSelector } from 'state';

export default function PasswordReset() {
  const { t } = useTranslation();
  const setToast = useSetRecoilState(toastStateSelector);

  const validationSchema = yup.object({
    email: yup
      .string()
      .email(t('login.errors.email') ?? '')
      .required(t('login.errors.mandatory') ?? ''),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: async values => {
      const { email } = values;
      try {
        const response = await resetPassword(email);

        if (response.status === 204) {
          setToast({
            isOpen: true,
            message: t('login.success.passwordResetLinkSent'),
            severity: ToastSeverity.success,
          });
        } else {
          setToast({
            isOpen: true,
            message: t('login.errors.passwordResetFailed'),
            severity: ToastSeverity.error,
          });
        }
      } catch (error) {
        console.error(error);
        setToast({
          isOpen: true,
          message: t('login.errors.passwordResetFailed'),
          severity: ToastSeverity.error,
        });
      }
    },
  });
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: '100vh' }}
    >
      <Paper elevation={3}>
        <form onSubmit={formik.handleSubmit}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            p={3}
            minWidth="500px"
          >
            <TextField
              fullWidth
              margin="normal"
              id="email"
              name="email"
              label={t('login.email')}
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
            <Box>
              <RouterLink to="/login">{t('login.backToLogin')}</RouterLink>
            </Box>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              sx={{ marginTop: '20px' }}
            >
              {t('login.sendPasswordResetLink')}
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}
